import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
export let isDebugMode = environment.isDebugMode

@Injectable()
export class ModalMessageService {

    constructor() {
        isDebugMode ? console.log(`constructor()`) : undefined
    }

}